import VueRouter, { RouteConfig } from 'vue-router'
import { PrizeType } from '../activity/logistics/model'

const Index = () => import('../activity/logistics/Index.vue')

export const logisticsRoute: RouteConfig = {
  path: '/logistics',
  name: 'logistics',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育作业管理系统',
  },
}

export default [logisticsRoute]

export function navigateToActivityLogistics(router: VueRouter, activityId: string, prizeType = PrizeType.Both) {
  router.push({ name: logisticsRoute.name, query: { activityId, prizeType } })
}

export function navigateToActivityLogisticsSchool(router: VueRouter, activityId: string) {
  navigateToActivityLogistics(router, activityId, PrizeType.School)
}

export function navigateToActivityLogisticsStudent(router: VueRouter, activityId: string) {
  navigateToActivityLogistics(router, activityId, PrizeType.Student)
}

export function navigateToActivityLogisticsTeacher(router: VueRouter, activityId: string) {
  navigateToActivityLogistics(router, activityId, PrizeType.Teacher)
}
